module.exports = {
  AUTH_CLIENT_ID: 'Z8RPsoNEtFZzcAnmgXOaQvf4rY4xwDF0',
  AUTH_CLIENT_DOMAIN: 'nex.auth0.com',
  API_URL: 'https://api.nexcrossing.com',
  ROOT_URL: 'https://cms.nexcrossing.com',
};
